<template>
  <transition name="fade">
    <div
      :style="{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        inset: 0,
        backgroundColor: 'white'
      }"
    >
      <ScaleLoader :color="$vuetify.theme.primary" />
    </div>
  </transition>
</template>

<script>
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'

export default {
  components: {
    ScaleLoader
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/FullscreenLoading.vue